import React from "react";
import { array, node, string } from "prop-types";

import HeroBrand from "../../../../ui/HeroBrand";
import HeroTitleSectionGraphpad from "./TitleSection/Graphpad";
import HeroTitleSectionSnapgene from "./TitleSection/Snapgene";
import HeroTitleSectionOmiq from "./TitleSection/Omiq";
import HeroTitleSectionLabarchives from "./TitleSection/Labarchives";
import HeroIconSectionSnapgene from "./IconSection/Snapgene";
import HeroIconSectionOmiq from "./IconSection/Omiq";
import HeroIconSectionGraphpad from "./IconSection/Graphpad";
import HeroIconSectionLabarchives from "./IconSection/Labarchives";
import heroConfig from "./heroConfig";

const brandHeroTitle = {
	sg: HeroTitleSectionSnapgene,
	om: HeroTitleSectionOmiq,
	gp: HeroTitleSectionGraphpad,
	la: HeroTitleSectionLabarchives,
};

const brandHeroIcons = {
	sg: HeroIconSectionSnapgene,
	om: HeroIconSectionOmiq,
	gp: HeroIconSectionGraphpad,
	la: HeroIconSectionLabarchives,
};

const SectionHero = ({ title, description, brandCode, items = [] }) => {
	const FactoryHeroTitleSection = brandHeroTitle[brandCode];
	const FactoryHeroIconSection = brandHeroIcons[brandCode];
	const iconsInside = heroConfig.iconsInside[brandCode];

	return (
		<>
			<HeroBrand brandCode={brandCode} config={heroConfig}>
				{FactoryHeroTitleSection ? (
					<FactoryHeroTitleSection title={title} description={description} />
				) : null}
				{iconsInside && FactoryHeroIconSection ? <FactoryHeroIconSection items={items} /> : null}
			</HeroBrand>
			{!iconsInside && FactoryHeroIconSection ? <FactoryHeroIconSection items={items} /> : null}
		</>
	);
};

SectionHero.propTypes = {
	title: string.isRequired,
	description: node.isRequired,
	brandCode: string.isRequired,
	items: array, // eslint-disable-line react/forbid-prop-types
};

export default SectionHero;
